import { render, staticRenderFns } from "./VueSmartSliderMarks.vue?vue&type=template&id=9a285ccc&scoped=true&"
import script from "./VueSmartSliderMarks.vue?vue&type=script&lang=ts&"
export * from "./VueSmartSliderMarks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a285ccc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a285ccc')) {
      api.createRecord('9a285ccc', component.options)
    } else {
      api.reload('9a285ccc', component.options)
    }
    module.hot.accept("./VueSmartSliderMarks.vue?vue&type=template&id=9a285ccc&scoped=true&", function () {
      api.rerender('9a285ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/component/ui/slider/VueSmartSliderMarks.vue"
export default component.exports